import React from "react";

export default function ProtocolENUS() {
  return (
    <div>
      <h1 style={{ textAlign: 'center' }}>Xiaomi Retail_User Agreement (Channel Retail)</h1>
      <div style={{ margin: '10px' }}>
        <p>&nbsp;</p>
        <p>
          <strong>
            PLEASE READ THE TERMS AND CONDITIONS CAREFULLY AND PAY ATTENTION TO
            PROVISIONS WHICH APPEAR IN BOLD AND CAPITAL LETTERS.
          </strong>
        </p>
        <p>&nbsp;</p>
        <p>
          You (also referred to as the "<strong>User</strong>") are requested to
          read and fully understand the terms and conditions of this User
          Agreement (referred to as the "<strong>Agreement</strong>"),
          <strong>
            in particular the terms and conditions relating to the Disclaimer,
            Limitation of Liability, No Agency or Partnership, Governing Law,
            Jurisdiction and Others, and any other terms highlighted in bold.
            Please read carefully and choose to accept or not accept this
            Agreement.
          </strong>
        </p>

        <p>
          <strong>We</strong> (Xiaomi Technologies Singapore Pte. Ltd., Xiaomi
          Technology Netherlands B.V., and all their affiliates and subsidiaries
          within Xiaomi Group, hereinafter referred to as "<strong>Xiaomi</strong>
          ")
          <strong>
            consider it the responsibility of the parent or guardian to supervise
            the child so that (s)he does not use Xiaomi Retail Software
          </strong>
          (hereinafter referred to as the "<strong>Software</strong>")
          <strong>
            and its related services, as we do not knowingly offer to minors, or
            knowingly process personal information of minors with, the Software or
            its related services.
          </strong>
        </p>

        <p>
          <strong>
            If you are a minor, please immediately stop using the Software and its
            related services, delete your data therein, and secure your parent's
            or guardian's help with these matters. Otherwise, Xiaomi does not
            enter into this Agreement with you, and your use of the Software and
            its related services is at your own risk.
          </strong>
        </p>

        <p>
          <strong>
            Unless you accept this Agreement in its entirety, you will not be able
            to properly register, log in, use (hereinafter collectively referred
            to as use) the Software and its related services.
          </strong>
        </p>

        <p>
          <strong>
            Once you use the Software and its related services, you are deemed to
            have fully understood this Agreement and agreed to accept the terms
            and conditions hereof and other agreements and rules, including but
            not limited to
            <a href="https://static.account.xiaomi.com/html/agreement/user/en_US.html">
              Xiaomi Account User Agreement
            </a>
            and the
          </strong>
          <strong>
            <a href="https://privacy.mi.com/miaccount/en_US/">
              Xiaomi Account Privacy Policy
            </a>
            , related to the Software and its related services as a party.
          </strong>
        </p>

        <p>&nbsp;</p>

        <h2>1. General Provisions</h2>
        <p>
          1.1 This is an agreement between you and Xiaomi, the operating body of
          the Software, regarding the use of the Software.
        </p>
        <p>
          1.2 Xiaomi Retail Software and its related services are the products and
          services provided to you by the software named "Xiaomi Retail",
          including but not limited to the provision of product management, sales
          volume reporting, promotion activity management, in-store inspection and
          other services (including any other forms of services that may appear in
          the future).
        </p>
        <p>
          1.3. The User understands that Xiaomi only provides the Software and its
          related services to the User, and that the costs of equipment (e.g.,
          personal computers) related to the Software and other services (e.g.,
          terminal fees, access fees for the Internet) shall be borne by the User.
          At the same time, the use of the Software and its related services will
          consume the User's equipment, bandwidth, traffic and other resources.
        </p>

        <h2>2. Use of the Software</h2>
        <p>
          2.1 You may use the Software and related services by downloading the
          Software from Xiaomi or a third party authorised by Xiaomi.
          <strong>
            If you do not obtain the Software from Xiaomi or a third party
            authorised by Xiaomi, Xiaomi cannot guarantee that the unofficial
            version of the Software can be used normally, and the losses you
            suffer as a result have nothing to do with Xiaomi.
          </strong>
        </p>
        <p>
          2.2 Xiaomi may have developed different versions of the Software for
          different terminal devices, and you should obtain, download and install
          the appropriate version in accordance with the actual equipment
          conditions. If you no longer use the Software and its related services,
          you can also uninstall the corresponding Software.
        </p>
        <p>
          2.3 To better enhance the user experience and services, Xiaomi will from
          time to time provide updates or modifications of the Software, including
          modifications, upgrades, functional enhancements, development of new
          services, software replacement, etc. You can update the corresponding
          version according to your own needs.
        </p>
        <p>
          2.4 To ensure the security of the Software and its related services,
          Xiaomi will, where feasible, prompt you through system alerts,
          announcements, webmail and other means after some or all updates of the
          Software and its related services. You have the right to choose to
          accept the updated version; if you choose not to update, some of the
          functions of the Software and its related services will be restricted or
          cannot be used normally.
        </p>

        <h2>3. Account Management</h2>
        <p>
          <strong>
            3.1 Users can log in to the Software through a Xiaomi account, and you
            agree to authorise the Software to obtain and use the information such
            as your Xiaomi Account ID, avatar and nickname.
          </strong>
        </p>
        <p>
          <strong>
            3.2 You understand and promise that the account you set up shall not
            violate any laws and regulations and the relevant rules of the
            Software, and that illegal and undesirable information shall not
            appear in your account name, avatar, profile and other personal
            information, and that you shall not open an account in the name of
            others without their permission (including, but not limited to,
            fraudulently using their names of natural persons, names of
            businesses, avatars, etc. in a way that causes confusion), and you
            shall not maliciously register for a Xiaomi Retail account (including
            but not limited to frequent registration, bulk registration of
            accounts and other similar behaviours).
          </strong>
        </p>
        <p>
          <strong>
            In the process of account registration, you need to comply with the
            laws and regulations, public interests, legitimate rights, public
            order, social morals and the authenticity of information etc. In case
            of violation of laws and regulations and the relevant policies of the
            Software, Xiaomi has the right to take action on your account and
            related information without notifying you, including cancellation,
            blocking, modification of the illegal information, restriction of the
            use of permissions, etc., without the need to assume any legal
            responsibility for the account to the User who registers the account.
            The resulting losses, including the interruption of user
            communications, user data and information and other losses shall be
            borne by the User.
          </strong>
        </p>
        <p>
          <strong>
            3.3 Your account is limited to your own use. Without the written
            consent of Xiaomi, it is prohibited to give, borrow, rent, transfer,
            sell or permit others to use the account in any form. If Xiaomi
            discovers or has reasonable grounds to believe that the user is not
            the initial registrant of the account, Xiaomi has the right, without
            notice, to suspend or terminate the provision of services to the
            registered account, cancel the account and delete all information
            related to the account and operation records of the account. The
            resulting losses, including the interruption of user communications,
            user data and information and other related rights and interests,
            etc., shall be borne by the User.
          </strong>
        </p>
        <p>
          <strong>
            3.4 You are responsible for maintaining the security and
            confidentiality of your account and password, and bear full legal
            responsibility for the activities you engage in the name of your
            registered account,
          </strong>
          including all the legal responsibilities that may arise from any
          modification of data, release of information, and other operational
          actions you may carry out on the Software and related services. You
          should attach great importance to the confidentiality of your account
          number and password, and not disclose your account number and password
          to others under any circumstances.
          <strong>
            If you find unauthorised use of your account or any other security
            breach, you should immediately notify Xiaomi, but no matter what the
            reason for the security breach is, the User is solely responsible, and
            Xiaomi does not assume any responsibility.
          </strong>
        </p>
        <p>
          3.5 You should keep your account credentials properly stored. When you
          have finished using it, you should exit it safely.
          <strong>
            If your account is stolen or your password is lost due to your own
            reasons such as improper storage or other uncontrollable factors, you
            will bear the corresponding responsibility. Xiaomi does not promise
            that users will be able to recover their accounts.
          </strong>
        </p>
        <p>
          <strong>
            3.6 When registering for an account, using and managing your account,
            you should ensure the authenticity and validity of the identity
            information you fill in. Please use true, accurate, legal and valid
            identification materials and necessary information (including, if
            required, your name and email address, contact phone number, contact
            address, etc.) when registering for and managing your account. If the
            information you submit or information you provide is inaccurate,
            untrue, illegal, invalid or Xiaomi has reasonable grounds to suspect
            that it is inaccurate, untrue, illegal or invalid, Xiaomi has the
            right to refuse to provide you with the relevant functions, and you
            may not be able or may be restricted to use the Software and related
            services.
          </strong>
        </p>

        <h2>4. Norms of Use</h2>
        <p>
          <strong>4.1 User Behaviour</strong>
        </p>
        <p>
          <strong>
            You shall be responsible for your use of the Software and its related
            services. Unless permitted by laws and regulations or with prior
            written permission from Xiaomi, your use of the Software and its
            related services shall not have the following behaviours:
          </strong>
        </p>
        <p>
          4.1.1 Remove any copyrighted information from the Software and other
          copies, as well as modify, delete or circumvent technical measures
          protecting intellectual property rights by the Software;
        </p>
        <p>
          4.1.2 Reverse engineering the Software, such as disassembling,
          decompiling, or otherwise attempting to obtain the source code of the
          Software;
        </p>
        <p>
          4.1.3 Adding, deleting, or changing the functions or operating effects
          of the Software by modifying or falsifying instructions or data in the
          operation of the Software, or operating or communicating to the public
          the software or methods used for the above purposes, whether or not such
          acts are for commercial purposes;
        </p>
        <p>
          4.1.4 Use the Software to conduct any act that endangers network
          security, including but not limited to: using unauthorised data or
          accessing unauthorised servers/accounts; accessing the public network or
          other people's operating systems and deleting, modifying, or adding to
          the stored information without permission; attempting to probe, scan, or
          test weaknesses in the Software's system or network without permission
          or other acts that undermine network security; attempting to interfere
          (or actually interfering) with or disrupt the normal operation of the
          Software's system or website; intentionally spreading malicious programs
          or viruses and other acts that disrupt and interfere with normal network
          information services; forging TCP/IP packet names or partial names;
        </p>
        <p>
          4.1.5 The User logs in or uses the Software and the services through
          third party compatible software or systems not developed, authorised or
          approved by Xiaomi, or creates, publishes or distributes the said tools;
        </p>
        <p>
          4.1.6 Without the written consent of Xiaomi, using the Software and/or
          its information in the unauthorised implementation of the following
          acts, including but not limited to: use, rent, loaning, copying,
          modification, linkage, reproduction, compilation or publication of the
          Software and/or its information, the establishment of mirror sites, the
          unauthorized use of the Software to develop derivatives of the Software,
          works, services, plug-ins, compatibility, interconnection and so on;
        </p>
        <p>
          4.1.7 Use the Software to publish, transmit, disseminate or store any
          content that violates your local laws;
        </p>
        <p>
          4.1.8 Use the Software to publish, transmit, disseminate, or store
          content that infringes on the intellectual property rights, trade
          secrets, and other legal rights of others;
        </p>
        <p>
          4.1.9 Use the Software to publish, transmit and disseminate advertising
          messages and spam;
        </p>
        <p>
          4.1.10 Collect the information or any data of other Users, such as email
          address, without authorization and their direct consent and subject to
          applicable laws.
        </p>
        <p>
          4.1.11 Other use of the Software and other services provided by Xiaomi
          in any way that is not lawful, for any purpose that is not lawful, or in
          any manner that is inconsistent with the permitted use under this
          Agreement.
        </p>
        <p>
          User shall not unilaterally reconcile when User and Xiaomi jointly file
          a lawsuit against any third party without written consent from Xiaomi.
          Xiaomi will reasonably notify you such lawsuit or action at law.
        </p>
        <p>
          <strong>
            In any case, if Xiaomi has reason to believe that any of your conduct
            violates or may violate the above agreement, Xiaomi may independently
            judge and deal with it, and has the right to terminate the provision
            of services to you without any prior notice, and pursue the relevant
            legal responsibility.
          </strong>
        </p>

        <p>
          <strong>4.2 Norms for the Use of the Content</strong>
        </p>
        <p>
          <strong>
            Without the prior written permission of Xiaomi, you shall not on your
            own or authorise, permit or assist any third party to do the following
            with respect to the information content in the Software and related
            services:
          </strong>
        </p>
        <p>
          4.2.1 Copying, reading and adopting the information content of the
          Software and related services for commercial purposes, including but not
          limited to publicity, increasing the number of readers and viewers, and
          so on;
        </p>
        <p>
          4.2.2 Unauthorised editing, collating and arranging of the information
          content of the Software and related services for display in channels
          other than the source page of the Software;
        </p>
        <p>
          4.2.3 Adopting any form of identification methods, including but not
          limited to special logos, special codes, etc., to generate traffic,
          readership guidance, transfer, hijacking and other adverse effects on
          the information content of the Software and related services by itself
          or assisting a third party to do so;
        </p>
        <p>
          4.2.4 Other acts of illegal access to or use of the information content
          of the Software and related services.
        </p>

        <p>
          <strong>4.3 User's liability</strong>
        </p>
        <p>
          4.3.1 The User is entirely responsible for any breach of the obligations
          under:
        </p>
        <div style={{ marginLeft: '10px', marginBottom: '8px' }}>
          <div style={{ display: 'flex' }}>
            <span style={{ marginRight: '8px', flexShrink: 0 }}>a.</span>
            <span>This Agreement, including its updated/amended version.</span>
          </div>
        </div>
        <p style={{ marginLeft: '10px' }}>
          <div style={{ display: 'flex' }}>
            <span style={{ marginRight: '8px', flexShrink: 0 }}>b.</span>
            <span>Any applicable laws or regulations in the relevant jurisdictions,
              including the jurisdiction where the User is based or from where the
              User is accessing and using the Software.</span>
          </div>
        </p>
        <p>
          4.3.2 For the consequences of any such breach, including any loss or
          damage which User or any third-party may incur or suffer,
          <strong>
            Xiaomi will bear no responsibility to User or to any third party in
            respect of such breach
          </strong>
          .
        </p>
        <p>
          4.3.3 Users shall hold/ensure Xiaomi free from any responsibility or
          liability for any claims or loss arising from User's actions and/or
          negligence.
        </p>

        <h2>5. Protection of Privacy</h2>
        <p>
          5.1 Xiaomi is committed to the protection of your personal information,
          and the protection of Users' personal information is one of the basic
          principles of Xiaomi. In the process of using the Software and its
          related services, you may need to provide your personal information
          (including but not limited to your Xiaomi Account ID, name, mobile phone
          number, and email address), so that Xiaomi can provide you with better
          services and corresponding technical support. In addition, for the
          purposes of shop management, human resource management, etc., Xiaomi
          will continue to use the above personal information and other personal
          information you provide to Xiaomi while you are using the Software and
          its related services. For details, please refer to
          <strong>
            <a href="https://s.g.mi.com/RMS/protocol/tc/en-US/privacyNotice">
              Xiaomi Retail Privacy Notice
            </a>
          </strong>
          and
          <strong>
            <a href="https://privacy.mi.com/all/en_GB/">Xiaomi Privacy Policy</a>
          </strong>
          .
        </p>

        <h2>6. Treatment of Non-compliance</h2>
        <p>
          <strong>
            6.1 In response to your violation of this Agreement or other terms of
            service, Xiaomi has the right to, at its discretion and depending on
            the circumstances, take preventive and/or final measures such as
            warning, refusal to publish, immediate stop of information
            transmission, restriction of some or all of the functions of the
            account, or the permanent closure of the account. Xiaomi has the right
            to notify you of its final decisions on such violations, and has the
            right to decide whether to restore the use of the relevant account
            according to the actual situation. For suspected violations of laws
            and regulations, Xiaomi will note suspected illegal and criminal acts
            in relevant records, report them to the relevant authorities, and
            cooperate with the relevant authorities to investigate as per relevant
            laws and regulations.
          </strong>
        </p>

        <p>
          <strong>
            6.2 If you violate the provisions of this Agreement or other terms of
            service and cause a third party to file a complaint or litigation
            claim, you shall deal with it on your own and bear all the legal
            liabilities that may arise from it. If you cause Xiaomi to pay
            compensation to any third party or suffer punishment by state organs
            due to your illegal or default behaviour, you shall also fully
            compensate Xiaomi for all the losses suffered as a result.
          </strong>
        </p>

        <p>
          <strong>
            6.3 Xiaomi respects and protects intellectual property rights, the
            right to reputation, the right to name, the right to privacy and other
            legitimate rights and interests of legal persons and citizens. You
            guarantee that the text, pictures, video, audio, links, etc. uploaded
            when using the Software and related services do not infringe any third
            party's intellectual property rights, right of reputation, right of
            name, right of privacy and other rights and legitimate interests.
            Otherwise, Xiaomi has the right to remove the allegedly infringing
            content upon receipt of notification from the right holder or related
            parties. For all the claims made by the third party, you shall handle
            them on your own and bear all the legal liabilities that may arise
            from it; if Xiaomi suffers losses (including economic and goodwill
            losses) due to your infringing behaviour, you shall also compensate
            Xiaomi in full for all the losses suffered by Xiaomi.
          </strong>
        </p>

        <h2>7. Third-party related agreement</h2>
        <p>
          <strong>
            7.1 If you use/visit the software/link and related services provided
            by third parties in the Software, in addition to complying with this
            Agreement and the relevant terms of the Software, you may also need to
            comply with the agreements and relevant rules of third parties. Any
            dispute, loss or damage arising from the third-party software and
            related services shall be resolved between you and the third party,
            and Xiaomi shall not be liable to you or any third party in this
            regard.
          </strong>
        </p>

        <p>
          <strong>
            7.2 The Software and services include content provided by other Users
            and you may interact with them. We do not control such interaction,
            bear legal liability, or own the obligations to check, monitor,
            examine and approve such contents. You bear legal liability for the
            risks of such interaction.
          </strong>
        </p>

        <h2>8. Disclaimer</h2>
        <p>
          <strong>
            8.1 You understand and agree that Xiaomi provides the Software and
            related services in accordance with the current state of the art of
            existing technology and conditions. Xiaomi will use its best
            endeavours to provide the services to you and to ensure the continuity
            and security of the services. You understand that Xiaomi cannot at all
            times foresee and prevent technical and other risks, including but not
            limited to force majeure, viruses, trojan horses, hacker attacks,
            system instability, third-party service defects and other security
            issues of the infestation of service interruptions, data loss and
            other losses and risks. If you incur any losses because of the above
            reasons, Xiaomi will not be responsible.
          </strong>
        </p>

        <p>
          <strong>
            8.2 You understand and agree that the Software and related services
            may be affected or interfered by various factors, and Xiaomi does not
            guarantee, including:
          </strong>
        </p>
        <p>
          <strong>
            8.2.1 The Software is fully suited to the User's requirements;
          </strong>
        </p>
        <p>
          <strong>
            8.2.2 The Software is uninterrupted, timely, secure, reliable or
            error-free; and that any software, services or other materials
            obtained by you meet the expectations of users;
          </strong>
        </p>
        <p>
          <strong>
            8.2.3 Any errors in the Software will be capable of being corrected.
          </strong>
        </p>

        <p>
          <strong>
            8.3 For suspected borrowing, financial management or other network
            information involving property, account passwords, advertisements or
            promotions, etc., please be careful and make your own judgement. If
            based on the foregoing reasons you suffer any loss of property,
            profits, business reputation, information or other tangible or
            intangible losses, Xiaomi does not assume any direct, indirect,
            incidental, special, consequential or punitive damages liability.
          </strong>
        </p>

        <p>
          <strong>
            8.4 You understand and agree that in the process of using the Software
            and related services, you may encounter force majeure and other
            factors (force majeure refers to unforeseeable, insurmountable and
            unavoidable objective events), including, but not limited to,
            governmental actions, regulatory policies, natural disasters, network
            reasons, hacker attacks, war or any other similar events. When force
            majeure occurs, Xiaomi will endeavour to address it in a timely
            manner, but if force majeure causes you to suspend, discontinue or
            terminate the service or cause any loss, you agree that Xiaomi does
            not bear any legal responsibility.
          </strong>
        </p>

        <p>
          <strong>
            8.5 You understand and agree that Xiaomi provides no warranty or
            condition of any kind, either express or implied, including but not
            limited to commercial merchantability, fitness for a particular
            purpose, etc., with respect to the Software and related services. Your
            use of the Software and related services is at your own risk.
          </strong>
        </p>

        <p>
          <strong>
            8.6 You understand and agree that the Agreement is to ensure
            compliance with laws and regulations, public orders and morals, and
            protect the legitimate rights and interests of others. Xiaomi in its
            ability will do its best to judge in accordance with relevant laws and
            regulations, but does not guarantee that Xiaomi's judgement is
            completely consistent with the judiciary or administrative
            authorities. For any consequences arising from such inconsistencies,
            you have understood and agreed to bear the full responsibility.
          </strong>
        </p>

        <h2>9. Limitation of Liability</h2>
        <p>
          <strong>
            9.1 Xiaomi shall not be held liable towards the Users, except in the
            case of willful misconduct or gross negligence, for disservices or
            malfunctions connected to the use of the internet outside of its own
            control or that of its suppliers.
          </strong>
        </p>

        <p>
          <strong>
            9.2 Furthermore, Xiaomi will not be liable for damages, losses and
            costs incurred by the Users as a result of failure to execute the
            Agreement for reasons not attributable to Xiaomi.
          </strong>
        </p>

        <p>
          <strong>9.3 Xiaomi shall not be held liable for:</strong>
        </p>
        <p>
          <div style={{ marginLeft: '10px', marginBottom: '8px' }}>
            <div style={{ display: 'flex' }}>
              <span style={{ marginRight: '8px', flexShrink: 0 }}>a.</span>
              <strong>
                any loss of business opportunities and any other loss, including
                indirect, possibly suffered by the User that is not a direct result of
                the breach of Agreement by Xiaomi;
              </strong>
            </div>
          </div>

        </p>
        <p>
          <div style={{ marginLeft: '10px', marginBottom: '8px' }}>
            <div style={{ display: 'flex' }}>
              <span style={{ marginRight: '8px', flexShrink: 0 }}>b.</span>
              <strong>
                unlawful, incorrect or unsuitable use of the Software by you or third
                parties.
              </strong>
            </div>
          </div>
        </p>

        <p>
          <strong>
            9.4 In the event that Xiaomi is liable for a breach of this Agreement,
            Xiaomi's liability shall be limited to damages which Xiaomi must
            typically expect at the time of the conclusion of the Agreement due to
            the circumstances known at the time. Notwithstanding the above, such
            damages shall not be higher than US Dollar One Hundred (100 USD) (or
            equivalent local currency on the date when the loss occurs).
          </strong>
        </p>

        <h2>10. Intellectual Property Rights</h2>
        <p>
          10.1 The intellectual property rights of the content (including
          software, technology, programs, web pages, text, pictures, images,
          audio, video, graphics, layout, electronic documents, etc.) provided by
          Xiaomi in the Software and related services belong to Xiaomi or the
          relevant right holders.
          <strong>
            Without the permission of Xiaomi or the relevant right holders, no one
            is allowed to use it (including copying, disseminating, displaying,
            mirroring, uploading, downloading, modifying, renting, etc.)
          </strong>
        </p>

        <p>
          <strong>
            10.2 You understand and agree that the text, images, video, audio,
            etc. posted and uploaded by you when using the Software and related
            services are either your original content or legally authorised to be
            used by you. Unless otherwise agreed by Users and Xiaomi, the
            intellectual property rights of any content uploaded or published by
            you through the Software belong to Xiaomi. Any reproductions,
            disseminating, displaying, modifying of the explanatory texts and the
            contents of the Software and any of its features (including but not
            limited to the content uploaded by you), if not authorized, will be
            considered violations of the intellectual property rights of Xiaomi.
          </strong>
        </p>

        <p>
          10.3 Xiaomi provides technical support for the development and operation
          of the Software and enjoys all rights within the scope of laws and
          regulations to all data and information generated in the process of
          development and operation of the Software and related services.
        </p>

        <p>
          <strong>
            10.4 You shall not under any circumstances privately use any of
            Xiaomi's trademarks, service marks, trade names, domain names and
            other logos, including but not limited to "Xiaomi Retail", etc.
            Without the prior written consent of Xiaomi, you shall not display,
            use or apply for registration of trademarks, domain names, etc., in
            any manner, either alone or in combination, nor shall you engage in
            any conduct that expressly or impliedly entitles you to display, use
            or otherwise deal with such marks. Any loss and legal responsibility
            caused by your violation of this Agreement to use Xiaomi's trademarks,
            logos, etc. to Xiaomi or others will be fully borne by you.
          </strong>
        </p>

        <h2>11. No Agency or Partnership</h2>
        <p>
          <strong>
            11.1 Nothing in this Agreement shall be construed as establishing any
            agency, partnership, joint venture, employee-employer or
            franchiser-franchisee relationship between Xiaomi and User. Neither
            party shall have the authority to act on behalf of, bind, or incur any
            liabilities or obligations in the name of the other party.
          </strong>
        </p>

        <p>
          <strong>
            11.2 Each Party acknowledges that it is an independent entity acting
            on its own behalf, and shall be solely responsible for its own
            actions, employees, agents, and representatives. No party shall be
            deemed to control, or have any liability for, the operations or
            obligations of the other party.
          </strong>
        </p>

        <h2>12. Confidentiality</h2>
        <p>
          12.1 Confidential information shall mean (1) any information or data
          created, generated, posted, uploaded, communicated on or through the
          Software, including the content uploaded by Users; (2) any information
          or data in relation to the existence, design, layout, building, feature,
          content, etc. of the Software, including the existence and the terms of
          the Agreement; and (3) any other business, technical or operational
          information of Xiaomi that is not publicly available.
        </p>

        <p>
          12.2 The receiving party shall take strict security measures to protect
          confidential information, including but not limited to establish a
          confidentiality system, train all relevant persons who could get access
          to confidential information, sign non-disclosure agreements with them,
          emphasize the security measures and liabilities of breaching such
          agreements.
        </p>

        <p>
          12.3 The receiving party shall be responsible for the leakage of
          confidential Information by its affiliates, personnel, agents and
          representatives.
        </p>

        <p>
          12.4 When this confidentiality section contradicts the provisions of
          other agreements otherwise executed by and between the parties, the
          stricter provisions shall prevail.
        </p>

        <h2>13. Governing Law, Jurisdiction and Others</h2>
        <p>
          <strong>
            13.1 This Agreement is subject to the laws of Hong Kong without regard
            to conflict of law principles, to the extent that it does not conflict
            with any mandatory rules applicable in the territories in which Xiaomi
            or the User are located.
          </strong>
        </p>

        <p>
          <strong>
            13.2 Any dispute, controversy, difference or claim arising out of or
            relating to the Agreement, including the existence, validity,
            application, performance, breach or termination thereof or any dispute
            regarding non-contractual obligations arising out of or relating to it
            shall be referred to and finally resolved by arbitration administered
            by Hong Kong International Arbitration Centre (HKIAC) under the
            UNCITRAL Arbitration Rules in force when the notice of arbitration is
            submitted, as modified by the HKIAC procedures for the administration
            of international arbitration.
          </strong>
        </p>

        <p>
          <strong>
            The dispute shall be heard by a single arbitrator, who shall be agreed
            upon by User and Xiaomi or if agreement is not reached by the parties
            within one month of service of the arbitration notice shall be
            appointed by the chairman of HKIAC.
          </strong>
        </p>

        <p>
          <strong>
            The arbitration shall be conducted in English and in Hong Kong.
          </strong>
        </p>

        <p>
          <strong>
            Nothing in this Agreement shall prevent User or Xiaomi from seeking
            urgent injunctive or similar relief from any court of competent
            jurisdiction if needed to enforce its rights under the Agreement and
            to this end, each of the parties irrevocably agrees that the courts of
            Hong Kong have exclusive jurisdiction to settle any such dispute or
            claim.
          </strong>
        </p>

        <p>
          <strong>
            13.3 Xiaomi reserves the right to amend this Agreement due to changes
            in laws and regulations and policies, products, and fulfilment
            environments, and the updated terms of this Agreement will be posted
            on the official website or the Software and will take effect from the
            date of posting. You may re-download and install the Software or the
            website to check the latest version of the terms of this Agreement. If
            you have any objections to the revised Agreement, please immediately
            stop logging in and using the Software and services; if you log in or
            continue to use the Software and related services, you are deemed to
            have approved the revised Agreement.
          </strong>
        </p>

        <p>
          13.4 The headings in this Agreement are for convenience and readability
          only and do not affect the meaning or interpretation of any provision of
          this Agreement.
        </p>

        <p>
          13.5 If any provisions of this Agreement are rendered invalid or
          unenforceable for any reason whatsoever, the remaining provisions shall
          remain in force and shall be binding on the parties.
        </p>

        <p>
          <strong>Latest Release: August 28, 2025</strong>
        </p>
      </div>
    </div>
  );
}
